import React from 'react'
import AdminFooter from '../sections/AdminFooter'
import AdminHeader from '../sections/AdminHeader'
import AppLayout from './AppLayout'
import { NavLink } from 'react-router-dom'


function AccountLayout({children}) {
    return (
        
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-3'>
                        <div className="list-group">
                            <NavLink to={"/transaction/dashboard"} className="list-group-item list-group-item-action">Transaction Dashboard</NavLink>
                            <NavLink to={"/transaction/list"} className="list-group-item list-group-item-action">Transaction List</NavLink>
                            <NavLink to={"/transaction/item-list"} className="list-group-item list-group-item-action">Transaction Item List</NavLink>
                            <NavLink to={"/transaction-category/dashboard"} className="list-group-item list-group-item-action">Transaction Cateory</NavLink>
                        </div>
                    </div>
                    <div className='col-md-9'>
                        {children}
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default AccountLayout